import React from "react";
import { isFeatureEnabled } from "utils/utils";
import "./EventCard.scss";

interface EventCardProps {
  image: string;
  title: string;
  venue: string;
  date: string;
}

const EventCard = (props: EventCardProps) => {
  const { image, title, venue, date } = props;
  const isShowThumbnailBlur = isFeatureEnabled("SHOW_THUMBNAIL_BLUR");

  return (
    <div className="col-12 mt-3">
      <div className="event">
        <div className="inner">
          <div className="thumbnail">
            {isShowThumbnailBlur && (
              <div
                className="img-blur"
                style={{ background: `url(${image}) 50% 80% / cover` }}
              />
            )}
            <img className="img-fluid" src={image} alt={title} loading="lazy" />
          </div>
          <div className="content">
            <div className="meta-info">
              <span className="date">
                <i className="bi bi-calendar-date">&nbsp;</i>
                {date}
              </span>
              <span className="location">
                <i className="bi bi-geo-alt-fill">&nbsp;</i>
                {venue}
              </span>
            </div>
            <h1 className="card-title">{title}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
